import React, { useContext } from 'react';
import classNames from 'classnames';
import Icon from "@scentregroup/ui/components/icon";
import { incBaseIdentity } from '../../../helpers/paths';
import { LinkContext } from '../context';
import style from './index.module.scss';
import Nav from '.';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

const Account = ({
  from = '',
  redirect,
  user,
  onClose
}) => {
  const Link = useContext(LinkContext);
  const path = redirect || "".concat(location.pathname).concat(location.search).concat(location.hash); // eslint-disable-next-line compat/compat

  const searchParams = new URLSearchParams({
    path
  });

  if (from !== '') {
    searchParams.append('from', from);
  }

  const loginUrl = "".concat(incBaseIdentity('login'), "?").concat(searchParams.toString());
  const signupUrl = "".concat(incBaseIdentity('register'), "?").concat(searchParams.toString());
  const logoutUrl = "".concat(incBaseIdentity('logout'), "?").concat(searchParams.toString());
  const items = user ? [() => /*#__PURE__*/_jsx("div", {
    className: classNames(style.item, style['item-big']),
    "data-test-id": "main-navdrawer-welcome-message",
    children: user.firstName ? "Hi, ".concat(user.firstName, "!") : 'Hi!'
  }), {
    label: 'Account',
    url: incBaseIdentity("account-info")
  }, {
    label: 'Orders',
    url: incBaseIdentity("account-info/orders")
  }, {
    label: 'Payment methods',
    url: incBaseIdentity("account-info/payment-methods")
  }, {
    label: 'Sign out',
    url: logoutUrl
  }] : [{
    label: 'Login',
    url: loginUrl,
    className: classNames(style['item-big'])
  }, {
    label: 'Sign up',
    url: signupUrl,
    className: classNames(style['item-big'])
  }, () => /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      className: classNames(style.item, style.title),
      children: "You get more with Westfield Plus"
    }), /*#__PURE__*/_jsxs("div", {
      className: classNames(style.item),
      children: [/*#__PURE__*/_jsx(Icon, {
        size: "medium",
        type: "wallet",
        className: classNames(style.icon)
      }), /*#__PURE__*/_jsx("span", {
        children: "Earn rewards when you Click & Collect"
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: classNames(style.item),
      children: [/*#__PURE__*/_jsx(Icon, {
        size: "medium",
        type: "delivery",
        className: classNames(style.icon)
      }), /*#__PURE__*/_jsx("span", {
        children: "Free delivery for orders $50 and over"
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: classNames(style.item),
      children: [/*#__PURE__*/_jsx(Icon, {
        size: "medium",
        type: "westfield-direct-returns",
        className: classNames(style.icon)
      }), /*#__PURE__*/_jsx("span", {
        children: "Free and easy returns"
      })]
    })]
  }), () => /*#__PURE__*/_jsx(Link, {
    target: "_blank",
    rel: "noopener noreferrer",
    to: '/westfield-plus',
    className: classNames(style.link, style.learnMoreLink, style.item),
    children: "Learn more"
  })];
  return /*#__PURE__*/_jsx(Nav, {
    className: classNames(style['nav-reverse']),
    items: items,
    onClose: onClose
  });
};

export default Account;